import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { activeTabFetcher } from '../../fetchers/batches-fetcher';

type Props = {
  data: ActiveTab[];
  isLoading: boolean;
};

type useActiveTabProps = {
  enabled?: boolean;
  batchSlug: string;
};

export const ACTIVE_TAB_QUERY_KEY = (batchSlug: string) => 'batch-active-tab-' + batchSlug;
const useActiveTab = ({ batchSlug, enabled }: useActiveTabProps): Props => {
  const { data, isLoading } = useQuery(
    [
      ACTIVE_TAB_QUERY_KEY(batchSlug),
      {
        batchId: batchSlug,
        params: {
          type: 'SAARTHI',
        },
      },
    ],
    activeTabFetcher,
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: enabled !== false && !!batchSlug,
      staleTime: 1000 * 60 * 60,
    },
  );

  const Data = useMemo(() => {
    const list: ActiveTab[] = [];
    data?.data?.forEach((element: any) => {
      list.push(new ActiveTab(element));
    });
    return list;
  }, [data]);
  return {
    data: Data,
    isLoading,
  };
};

class ActiveTab {
  _id: string;
  type: string;
  typeId: string;
  defaultSaarthiPlanId: string;

  constructor(data: any = {}) {
    this._id = data?._id || '';
    this.type = data?.type || '';
    this.typeId = data?.typeId || '';
    this.defaultSaarthiPlanId = data?.defaultSaarthiPlanId || '';
  }
}

export default useActiveTab;
